import * as z from 'zod/mini';
import { SideLinesData } from './sidelineUtils';

export const sportsBetSchema = z.object({
  type: z.string().check(z.minLength(2), z.trim()),
  backgroundColor: z.string().check(z.minLength(4), z.trim()),
  odds: z.number(),
  marketId: z.string().check(z.minLength(2), z.trim()),
  marketName: z.string().check(z.minLength(2), z.trim()),
  marketType: z.string().check(z.minLength(2), z.trim()),
  gameId: z.string().check(z.minLength(5), z.trim()),
});

export const sportsBetWithEntityInfo = z.object({
  ...sportsBetSchema.shape,
  entityType: z.string(),
  entityId: z.string(),
});

type SchemaBets = typeof sportsBetSchema | typeof sportsBetWithEntityInfo;

export const validateSchema = (schema: SchemaBets) => (data: SideLinesData) => {
  const result = schema.safeParse(data);
  if (!result.success) {
    console.warn('Validation failed:', result.error);
    return null;
  }
  return data;
};
